import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import { IconFont } from '../../../component/icon-font';
import CrosshairIcon from '../../../component/svgs/new/crosshair.svg';
import CrosshairDisabledIcon from '../../../component/svgs/new/crosshair-disabled.svg';

export interface PoseDetectionProps {
  text: string;
  tipText: string;
  status: PoseDetectionStatus | '';
  icon: string;
  hoverIcon: string;
  onClick?: () => void;
  disabled?: boolean;
}

export enum PoseDetectionStatus {
  Enabled = 'Enabled',
  Disabled = 'Disabled'
}

export const getPoseDetectionButtons = (status: PoseDetectionStatus | '', isHost: boolean) => {
  if (!isHost) return null;

  if (status === PoseDetectionStatus.Disabled) {
    return {
      text: 'Enable',
      tipText: 'Enable Pose Detection',
      status,
      icon: 'icon-pose-detection',
      hoverIcon: 'icon-pose-detection-hover'
    };
  } else if (status === PoseDetectionStatus.Enabled) {
    return {
      text: 'Disable',
      tipText: 'Disable Pose Detection',
      status,
      icon: 'icon-pose-detection-disable',
      hoverIcon: 'icon-pose-detection-hover'
    };
  }
  return null;
};

const PoseDetectionButton = (props: PoseDetectionProps) => {
  const { tipText, icon, status, hoverIcon, onClick, disabled = false } = props;
  return (
    <Tooltip title={tipText}>
      <button
        onClick={onClick}
        disabled={disabled}
        style={{
          ...styles.circleBtn,
          ...(status === PoseDetectionStatus.Enabled ? styles.redBtn : styles.whiteBtn)
        }}
        className="press-effect-btn"
        title={'Share screen'}
      >
        <img
          src={status === PoseDetectionStatus.Enabled ? CrosshairDisabledIcon : CrosshairIcon}
          alt="magic"
          style={{
            width: 24,
            height: 24
          }}
        />
      </button>
    </Tooltip>
  );
};

export { PoseDetectionButton };

const styles = {
  circleBtn: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    border: 'none'
  },
  whiteBtn: {
    background: '#f0f0f0',
    color: '#1a1a1a'
  },
  redBtn: {
    background: '#C0392B',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(192,57,43,0.4)'
  }
};
